import React, { Fragment, useState } from "react";
import Header from "../../components/header3/Header3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import aImg from "../../images/about/about_image_3.webp";
import aImg2 from "../../images/about/about_image_4.webp";
import ModalVideo from "react-modal-video";
import PolicySection from "./Policy";
import WhyUs from "./WhyUs";
import FeaturesSection from "../../components/FeaturesSection/FeaturesSection";
import SEO from "../../components/seo/SEO";

import CtaSection from "../../components/CtaSection/CtaSection";

const AboutUsPage = (props) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <Fragment>
      <SEO
        title="Top Charter Firm in Delhi NCR | Binod Verma & Co."
        description="Expert CA firm in Delhi NCR for taxation, GST, audits, societies, NGOs & financial services. 15+ years trusted experience."
        keywords="Chartered Accountant Delhi, CA in Delhi NCR, GST Filing Delhi, Audit Firm Delhi, CA in Noida, CA in Gurgaon, Tax Consultant Delhi, NGO Audit Delhi, Financial Services Delhi, Accounting Services Delhi, Taxation Services Delhi"
        canonical="https://www.binodverma.com/"
        ogImage="https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg"
        schemaMarkup={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "AccountingService",
              name: "Binod Verma & Co.",
              image:
                "https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg",
              description:
                "Chartered Accountant in Delhi NCR specializing in taxation, GST, audits, NGOs & accounting services.",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Laxmi Nagar",
                addressLocality: "Delhi",
                addressRegion: "Delhi",
                postalCode: "110092",
                addressCountry: "India",
              },
              areaServed: ["Delhi", "Noida", "Gurgaon"],
              url: "https://www.binodverma.com",
            },
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Which is the best CA firm in Delhi for startups?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Binod Verma & Co. provides tax filing, GST, and audit solutions tailored for Delhi-based startups.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you provide NGO audit services in Noida?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we specialize in NGO and society audits in Noida with compliance-focused services.",
                  },
                },
              ],
            },
          ],
        }}
      />
      <Header />
      <main className="page_content about-page">
        <PageTitle
          pageTitle={"About Us"}
          pagesub={"B&B Co. "}
          pageTop={"About"}
        />
        <section className="intro_about_section section_space bg-light">
          <div className="intro_about_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="image_wrap">
                    <img src={aImg} alt="B&B Co. - About " />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="image_wrap position-relative">
                    <img src={aImg2} alt="B&B Co. - About" />
                    <button
                      className="video_btn ripple_effect"
                      onClick={() => setOpen(true)}
                    >
                      <span className="btn_icon">
                        <i className="fa-solid fa-play"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="heading_block mb-0">
              <div className="row justify-content-lg-between">
                <div className="col-lg-4">
                  <div className="heading_focus_text">
                    About
                    <span className="badge bg-secondary text-white">
                      Binod Verma & Co.
                    </span>
                  </div>
                  <h1 className="heading_text mb-0">
                    Trusted Financial Advisors for Over 15 Years
                  </h1>
                </div>
                <div className="col-lg-6">
                  <p className="heading_description mb-0">
                    We don’t believe in one-size-fits-all solutions. Our team
                    adapts to your unique challenges—whether it’s navigating
                    complex audits, optimizing tax positions, or ensuring smooth
                    regulatory compliance. What sets us apart is our blend of
                    technical expertise and personalized attention, making your
                    growth and peace of mind our top priorities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <PolicySection />
        <FeaturesSection />
        {/* <TeamSection /> */}
        <WhyUs />
        <CtaSection />
      </main>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="i-v6oeVxtNM"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};
export default AboutUsPage;
